
import { Component, Inject, Vue } from "vue-property-decorator";
import { Container } from "inversify";
// @ts-ignore
import ClickOutside from "vue-click-outside";
import { AuthStore } from "../../../../common/src/stores/AuthStore";
import { SidebarStore } from "../../../../common/src/stores/SidebarStore";
import FormMultiSelect from "../../../../landing/src/molecules/form/FormMultiSelect.vue";
import SearchBar from "../components/SearchBar.vue";
import ProvideFeedback from "../../../../common/src/feedback/ProvideFeedback.vue";
import RecommendOrganization from "../../../../common/src/feedback/RecommendOrganization.vue";
import {
    isAdmin,
    isQuiltySubscribed,
    isSubscribed,
    isThirdpartyAdmin,
    MAX_FREE_ORGANIZATION_SEARCH,
} from "@gsx/common";
import { SelectOption } from "../../../../landing/src/molecules/form/types";
import { OrganizationListStore } from "../../stores/organization/OrganizationListStore";
import { debounce } from "lodash";
import {
    FeedbackModalStore,
    FeedbackModalType,
} from "../../../../common/src/feedback/FeedbackModalStore";
import MobileNavigation from "./MobileNavigation.vue";
import { event } from "vue-gtag";
import { handleError } from "../../../../common/src/utility/errorUtils";

enum SearchType {
    Unknown = "unknown",
    Organizations = "organizations",
    Products = "products",
    Services = "services",
}

@Component({
    components: {
        MobileNavigation,
        RecommendOrganization,
        ProvideFeedback,
        SearchBar,
        FormMultiSelect,
    },
    directives: { ClickOutside },
})
export default class Navbar extends Vue {
    @Inject("container") container!: Container;
    authStore: AuthStore = this.container.get(AuthStore);
    sidebarStore: SidebarStore = this.container.get(SidebarStore);
    isDropdownOpen: boolean = false;
    readonly organizationListStore: OrganizationListStore = this.container.get(
        "OrganizationSearchListStore",
    );
    readonly feedbackModalStore: FeedbackModalStore = this.container.get(FeedbackModalStore);

    searchType: SearchType = SearchType.Unknown;
    previousOrganizations: any[] = [];

    created() {
        this.organizationListStore.pageSize = 5;
        this.organizationListStore.load().catch(handleError);
    }

    get hasAdminAccess(): boolean {
        return isAdmin(this.authStore.user);
    }

    get hasThirdpartyAdminAccess(): boolean {
        return isThirdpartyAdmin(this.authStore.user);
    }

    get hasSearches() {
        let showOrgs = true;
        const tracker = this.authStore.user!.organizationSearchTracker;
        if (
            tracker &&
            !this.hasAdminAccess &&
            !this.hasThirdpartyAdminAccess &&
            !isSubscribed(this.authStore.user) &&
            !isQuiltySubscribed(this.authStore.user)
        ) {
            if (
                new Date(tracker.date).getMonth() === new Date().getMonth() &&
                tracker.count >= MAX_FREE_ORGANIZATION_SEARCH
            ) {
                showOrgs = false;
            }
        }

        return showOrgs;
    }

    get organizationOptions(): SelectOption[] {
        const orgs = this.organizationListStore.items || this.previousOrganizations;

        this.previousOrganizations = orgs;

        let orgsSelectOptions = orgs.map((organization) => ({
            id: organization.organizationid,
            name: organization.organizationDBA,
            secondaryText: organization.organizationName,
        }));

        const result = this.hasSearches ? orgsSelectOptions : [];

        return result;
    }

    navigateToOrganization(option: SelectOption) {
        this.$router.push(`/organizations/${option.id}`);
    }

    updateSearchDebounce = debounce(this.updateSearch, 400);

    updateSearch(query: string) {
        this.organizationListStore.query = query;
        this.organizationListStore.reload().catch(handleError);

        event("Search", {
            eventCategory: "Search",
            eventAction: "nav search",
            eventLabel: query,
        });
    }

    toggleDropdown() {
        this.isDropdownOpen = !this.isDropdownOpen;
    }

    closeDropdown() {
        this.isDropdownOpen = false;
    }

    async signout() {
        await this.authStore.signout();
        window.location.href = "/";
    }

    get FeedbackModalType() {
        return FeedbackModalType;
    }
}
